
import { Vue, Options } from "vue-class-component";
import Instruction from "./Instruction.vue";

@Options({
  components: {
    Instruction
  }
})
export default class AddToHomeScreen extends Vue {
  showInstruction = false;

  toggleShowInstruction() {
    this.showInstruction = !this.showInstruction;
  }
}
